import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index.js";

export const getInspectionList = createAsyncThunk( "utils/get-inspection-list", async (payload) => {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/utils/app/v1/get-inspection-list`, payload);
        return response;
    }
);
